import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import AddSynthetics from "../trading/AddSynthetics";

const AddSyntheticsDialog = ({ open, onClose, refresh }) => {
  const handleRefresh = () => {
    if (refresh) refresh();
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundImage: "none" } }}
    >
      <Box
        sx={{
          "& .add-media-card": {
            boxShadow: "none !important",
            border: "none !important",
            background: "transparent !important",
          },
        }}
      >
        <AddSynthetics refresh={handleRefresh} />
      </Box>
    </Dialog>
  );
};

export default AddSyntheticsDialog;
